/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PeopleInThePlaceTheyLove,
  PeopleInThePlaceTheyLoveInterface,
} from "../PeopleInThePlaceTheyLove";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "default_admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "authority",
        type: "address",
      },
      {
        internalType: "address",
        name: "payee",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "maxSupply_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "isBurningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "provenance",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
    payable: true,
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "toggleBurningActive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tos",
        type: "address[]",
      },
    ],
    name: "privateMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "bytesURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "provenance_",
        type: "bytes32",
      },
      {
        internalType: "uint256[]",
        name: "userTierIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "userTierStartTimes",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "userTierDurations",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "userTierTicketMaxNums",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "userTierTicketPrices",
        type: "uint256[]",
      },
    ],
    name: "createLuckyDraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "userTierId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ticketNum",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "draw",
    outputs: [],
    stateMutability: "payable",
    type: "function",
    payable: true,
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "recipients",
        type: "address[]",
      },
      {
        internalType: "uint96[]",
        name: "fractions",
        type: "uint96[]",
      },
    ],
    name: "payout",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type PeopleInThePlaceTheyLoveConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PeopleInThePlaceTheyLoveConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PeopleInThePlaceTheyLove__factory extends ContractFactory {
  constructor(...args: PeopleInThePlaceTheyLoveConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "PeopleInThePlaceTheyLove";
  }

  deploy(
    default_admin: string,
    authority: string,
    payee: string,
    maxSupply_: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PeopleInThePlaceTheyLove> {
    return super.deploy(
      default_admin,
      authority,
      payee,
      maxSupply_,
      overrides || {}
    ) as Promise<PeopleInThePlaceTheyLove>;
  }
  getDeployTransaction(
    default_admin: string,
    authority: string,
    payee: string,
    maxSupply_: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      default_admin,
      authority,
      payee,
      maxSupply_,
      overrides || {}
    );
  }
  attach(address: string): PeopleInThePlaceTheyLove {
    return super.attach(address) as PeopleInThePlaceTheyLove;
  }
  connect(signer: Signer): PeopleInThePlaceTheyLove__factory {
    return super.connect(signer) as PeopleInThePlaceTheyLove__factory;
  }
  static readonly contractName: "PeopleInThePlaceTheyLove";
  public readonly contractName: "PeopleInThePlaceTheyLove";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PeopleInThePlaceTheyLoveInterface {
    return new utils.Interface(_abi) as PeopleInThePlaceTheyLoveInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PeopleInThePlaceTheyLove {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PeopleInThePlaceTheyLove;
  }
}
